export enum UserType {
  Advertiser = 'Advertiser'
}

export interface ClaimPlace {
  business_id: string;
  url: string;
  img: string;
  phone: string | null;
  title: string;
  website: string | null;
  display_website: string | null;
  email: string | null;
  address: string | null;
}

export type MyPlace = ClaimPlace & {
  id: number;
  url: string;
};

export enum Social {
  Ter = 'ter',
  Transfans = 'transfans',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Telegram = 'telegram',
  Whatsapp = 'whatsapp',
  Tiktok = 'tiktok',
  Loyalfans = 'loyalfans',
  Wechat = 'wechat',
  Line = 'line',
  Tumblr = 'tumblr',
}

export type DayOfWeek =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

export type Socials =
  | 'line'
  | 'tumblr'
  | 'onlyfans'
  | 'whatsapp'
  | 'ter'
  | 'facebook'
  | 'instagram'
  | 'telegram'
  | 'wechat';

export interface DailyTimesheet {
  enabled: boolean;
  start: string;
  end: string;
  allDay: boolean;
}

export type CDNSizes =
  | '2560'
  | '1280'
  | '600'
  | '250'
  | 'webp2560'
  | 'webp1280'
  | 'webp600'
  | 'webp250'
  | 'origin';

type Thumbnails = {[key in CDNSizes]?: string};

export interface TPlaceImage {
  src: string;
  isMain: boolean;
  thumbs?: Thumbnails;
}

interface PlaceVideo {
  id: string;
  thumb: string;
  video: string;
}

export interface TPlace {
  business_id: string;
  title: string;
  url: string;
  website: string | null;
  display_website: string | null;
  tags: string[];
  phone: string;
  email: string;
  about: string;
  country: string;
  state: string | null;
  city: string | null;
  hours: {
    [key in DayOfWeek]: DailyTimesheet;
  };
  img: TPlaceImage[];
  socials: {
    [key in Social]: string | null;
  };
  onlyfans: string;
  badges: string[];
  address: string;
  videos: Array<PlaceVideo>;
}

export type TListResponse<T> = {
  items: T[];
  total: number;
};

export interface CheckUrlResponse {
  success: boolean;
  notFound: boolean;
  notAccessible: boolean;
  redirectToExternal: boolean;
  message: string;
}
